export default {
  theme   : 'modern',
  skin_url: '/assets/tinymce/skins/custom',

  external_plugins: {
    anchor       : '/assets/tinymce/plugins/anchor/plugin.min.js',
    code         : '/assets/tinymce/plugins/code/plugin.min.js',
    contextmenu  : '/assets/tinymce/plugins/contextmenu/plugin.min.js',
    fullscreen   : '/assets/tinymce/plugins/fullscreen/plugin.min.js',
    image        : '/assets/tinymce/plugins/image/plugin.min.js',
    link         : '/assets/tinymce/plugins/link/plugin.min.js',
    advlist      : '/assets/tinymce/plugins/advlist/plugin.min.js',
    lists        : '/assets/tinymce/plugins/lists/plugin.min.js',
    paste        : '/assets/tinymce/plugins/paste/plugin.min.js',
    preview      : '/assets/tinymce/plugins/preview/plugin.min.js',
    searchreplace: '/assets/tinymce/plugins/searchreplace/plugin.min.js',
    table        : '/assets/tinymce/plugins/table/plugin.min.js',
  },

  extended_valid_elements: 'iframe[src]',

  toolbar: [
    'bold italic underline',
    'bullist numlist link',
    'alignleft aligncenter alignright alignjustify',
    'fullscreen',
  ].join(' | '),

  contextmenu              : 'paste link image code fullscreen',
  menubar                  : false,
  statusbar                : false,
  media_alt_source         : false,
  media_poster             : false,
  media_dimensions         : false,
  paste_word_valid_elements: 'b,strong,i,em,h1,h2',
  height                   : 300,
  inline                   : false,

  paste_postprocess: function (plugin, args) {
    return [
      {
        regex         : /(?:http:\/\/|https:\/\/){0,1}(?:www\.){0,1}youtu\.be\/([\w\-]+)/g,
        replacePattern: '(?:http:\/\/|https:\/\/){0,1}(?:www\.){0,1}youtu\.be\/',
        type          : 'iframe',
        w             : 425,
        h             : 350,
        url           : '//www.youtube.com/embed/$1'
      },

      {
        regex         : /(?:http:\/\/|https:\/\/){0,1}(?:www\.){0,1}youtube\.com\/watch\?v=([\w\-]+)/g,
        replacePattern: '(?:http\:\/\/|https\:\/\/){0,1}(?:www\.){0,1}youtube\.com(?:[^\s]+)v=',
        type          : 'iframe',
        w             : 425,
        h             : 350,
        url           : '//www.youtube.com/embed/$1'
      },

      {
        regex         : /(?:http\:\/\/|https\:\/\/){0,1}(?:www\.){0,1}vimeo\.com\/([0-9]+)/g,
        replacePattern: '(?:http\:\/\/|https\:\/\/){0,1}(?:www\.){0,1}vimeo\.com\/',
        type          : 'iframe',
        w             : 425,
        h             : 350,
        url           : '//player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=8dc7dc'
      }
    ].forEach(function (pattern) {
      let
        match,
        replacePattern,
        results,
        url;

      results = [];

      while (match = pattern.regex.exec(args.node.innerHTML)) {
        let
          i = 0;

        url = pattern.url;

        while (match[i]) {
          url = url.replace('$' + i, function () {
              return match[i];
          });
          i++;
        }

        replacePattern = new RegExp(pattern.replacePattern + match[1]);

        results.push(args.node.innerHTML = args.node.innerHTML.replace(
          replacePattern,
          '<p class="article__fluid-width-video-wrapper"><iframe src="' + 'https:' + url + '"></iframe></p>',
        ));
      }

      return results;
    });
  },
};



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/tinymce-config.ts